import { render, staticRenderFns } from "./_userNoteModal.vue?vue&type=template&id=c8128138"
import script from "./_userNoteModal.vue?vue&type=script&lang=js"
export * from "./_userNoteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports